import { createSelector } from '@reduxjs/toolkit';
import type { IConfig } from '@cian/config/shared';

import { selectIsBlackFridayEtazhi } from 'shared/selectors/jsonQuery';
import type { IEtazhiBlackFridayFilterData } from './types';

/**
 * @todo: Код появился в задаче CD-250097, удалить в задаче CD-250490.
 */
export const selectBlackFridayEtazhiFilter = (config: IConfig) => {
  const isProjectEnabled = config.get<boolean>('proApp.etazhiBlackFridayEnabled');
  const filterData = config.get<IEtazhiBlackFridayFilterData>('proApp.etazhiBlackFridayFilterData');

  return createSelector(selectIsBlackFridayEtazhi, value => {
    const data = filterData?.desktop || null;
    /**
     * @todo: Выключена РС проекта, выключена РС данных фильтров, или нет имени фильтра - скрываем фильтр.
     */
    const isVisible = isProjectEnabled && Boolean(data?.enabled) && Boolean(data?.name);

    return {
      filterData: data,
      value: Boolean(value),
      visible: isVisible,
    };
  });
};
